import { render, staticRenderFns } from "./VColorPickerField.vue?vue&type=template&id=6decd260&scoped=true"
import script from "./VColorPickerField.vue?vue&type=script&setup=true&lang=ts"
export * from "./VColorPickerField.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./VColorPickerField.vue?vue&type=style&index=0&id=6decd260&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6decd260",
  null
  
)

export default component.exports